import React from 'react';
import {
  formatOrderBillingLabel,
  formatOrderMoney,
  isSubscriptionCreditOrder,
  resolveOrderCreditsConsumed,
  resolveOrderPlatformFee,
  resolveRestaurantSettlementAmount,
} from '../orderBillingUtils';
import '../css/OrderBillingCell.css';

export default function OrderBillingCell({ order }) {
  const subscription = isSubscriptionCreditOrder(order);
  const settlement = resolveRestaurantSettlementAmount(order);
  const credits = resolveOrderCreditsConsumed(order);
  const platformFee = resolveOrderPlatformFee(order);

  return (
    <div className="order-billing-cell">
      <span
        className={`order-billing-pill${
          subscription ? ' order-billing-pill--subscription' : ''
        }`}
      >
        {formatOrderBillingLabel(order)}
      </span>
      {subscription ? (
        <span className="order-billing-cell__meta">
          {settlement != null ? formatOrderMoney(settlement) : '—'}
          {credits != null ? ` · ${credits} cr` : ''}
        </span>
      ) : (
        platformFee != null &&
        parseFloat(platformFee) > 0 && (
          <span className="order-billing-cell__meta">
            Fee {formatOrderMoney(platformFee)}
          </span>
        )
      )}
    </div>
  );
}
